export const HOME_WIDGET = {
  POPUP_PAGES: {
    create: 0,
    invite: 1
  }
}
